import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"
import { normalizeMetricGoalTypes } from "../../lib/utils/metricGoalTypesReport"
import { skipIfCatalogLoaded } from "../utils/fetchDedupe"

/**
 * GET /api/v1/metric-goals/types
 */
export const fetchMetricGoalTypes = createAsyncThunk(
  "metricGoalTypes/fetch",
  async (_arg, { rejectWithValue }) => {
    try {
      const data = await get("metric-goals/types")
      return normalizeMetricGoalTypes(data)
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch metric goal types")
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force) return true
      return !skipIfCatalogLoaded(getState().metricGoalTypes)
    },
  },
)

const initialState = {
  types: [],
  status: "idle",
  error: null,
}

const metricGoalTypesSlice = createSlice({
  name: "metricGoalTypes",
  initialState,
  reducers: {
    clearMetricGoalTypes: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetricGoalTypes.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchMetricGoalTypes.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.types = action.payload ?? []
      })
      .addCase(fetchMetricGoalTypes.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch metric goal types"
      })
  },
})

export const { clearMetricGoalTypes } = metricGoalTypesSlice.actions
export default metricGoalTypesSlice.reducer
